import Api from 'utils/api'

interface FetchDepartmentsParams {
  offset?: number
  ordering?: string[]
  search?: string
}

export const fetchDepartments = ({ offset, ordering, search }: FetchDepartmentsParams) =>
  Api.get(['departments'], { offset, ordering, search })

export const fetchDepartment = ({ id }: { id: number | string }) => Api.get(['departments', id])
